var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray",attrs:{"id":"app"}},[_c('header-comp'),_c('router-view'),_c('cookieConsent',{ref:"cookieConsent"}),_c('footerComp',{on:{"revoke":_vm.revoke}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }